import { BrowserRouter } from 'react-router-dom';
import Routes from 'src/routes/Routes';
import Footer from 'src/components/Footer';
import RouteScrollReset from 'src/components/RouteScrollReset';

import '@fontsource/figtree/400.css';
import '@fontsource/figtree/500.css';
import '@fontsource/figtree/600.css';
import '@fontsource/figtree/700.css';
import '@fontsource/figtree/800.css';
import '@fontsource/orbitron/600.css';
import '@fontsource/orbitron/800.css';
import 'src/assets/css/index.css';

const App = () => {
  return (
    <BrowserRouter future={{ v7_relativeSplatPath: true }}>
      <RouteScrollReset />
      <Routes />
      <Footer />
    </BrowserRouter>
  );
};

export default App;
